// ABOUTME: Create deposit dialog hook using global dialog store
// ABOUTME: Manages deposit creation dialog state

import { useGlobalDialogs } from "@/shared/model/global-dialogs";

const DIALOG_ID = "deposit";

export function useCreateDepositDialog() {
  const { isOpen, open: openDialog, close } = useGlobalDialogs();

  return {
    isOpen: isOpen(DIALOG_ID),
    setIsOpen: (open: boolean) => (open ? openDialog(DIALOG_ID) : close()),
    open: () => openDialog(DIALOG_ID),
    close,
  };
}
